export const FutureTrendsSection = () => {
  const trends = [
    {
      number: '1',
      period: '2024–2025',
      description:
        'KI-gestütztes Energiemanagement und autonome Ladeoptimierung werden Standard.',
    },
    {
      number: '2',
      period: '2025–2027',
      description:
        'Solid-State-Batterien erhöhen Energiedichte und Sicherheit bei sinkenden Kosten.',
    },
    {
      number: '3',
      period: '2027–2030',
      description:
        'Vehicle-to-Grid (V2G) und Second-Life-Batterien aus E-Fahrzeugen ergänzen BESS-Parks.',
    },
    {
      number: '4',
      period: '2030+',
      description:
        'Vollständig dekarbonisierte Rechenzentren auf Basis von BESS und 100 % erneuerbarer Energie.',
    },
  ];

  return (
    <section id="future" className="relative py-12 sm:py-20 bg-gradient-to-b from-muted to-background overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
            {/* Left Column - Content */}
            <div className="py-4 z-10 relative">
              {/* Header */}
              <p className="text-base sm:text-xl text-muted-foreground font-normal mb-2">
                Zukünftige Trends:
              </p>
              <h2 className="font-heading font-bold text-2xl sm:text-4xl lg:text-5xl text-primary mb-6">
                Wie BESS die Rechenzentrumslandschaft verändert
              </h2>
              <p className="text-base sm:text-lg text-muted-foreground leading-relaxed mb-8 sm:mb-12">
                Die Konvergenz von KI, Edge Computing und Energiewende treibt
                die BESS-Innovation in neue Dimensionen. Die Zukunft gehört
                intelligenten, vernetzten Speichersystemen.
              </p>

              {/* Compact Timeline with More Whitespace */}
              <div className="relative pl-12 sm:pl-16">
                {/* Vertical Line */}
                <div className="absolute left-4 sm:left-6 top-2 bottom-2 w-0.5 bg-border" />

                {/* Timeline Items */}
                <div className="space-y-8 sm:space-y-12">
                  {trends.map((trend, index) => (
                    <div key={index} className="relative">
                      {/* Number Marker */}
                      <div className="absolute -left-12 sm:-left-16 top-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary flex items-center justify-center shadow-md">
                        <span className="text-primary-foreground font-heading font-bold text-base sm:text-lg">
                          {trend.number}
                        </span>
                      </div>

                      {/* Content */}
                      <div className="pb-2">
                        <div className="font-heading font-semibold text-lg text-primary mb-4">
                          {trend.period}
                        </div>
                        <p className="text-foreground leading-relaxed text-base pr-4">
                          {trend.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column - Full Height Image */}
            <div className="relative md:-mr-[calc((100vw-100%)/2+1rem)] min-h-[300px] md:min-h-[600px] lg:min-h-[700px]">
              <div className="h-full w-full overflow-hidden rounded-lg md:rounded-none">
                <img
                  src="https://customer-assets.emergentagent.com/job_datacenter-energy-1/artifacts/bhp1gx2m_Datacenter.png"
                  alt="Future Datacenter Technology"
                  className="w-full h-full min-h-[300px] md:min-h-[600px] lg:min-h-[700px] object-cover object-center"
                  loading="lazy"
                />
                {/* Subtle Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-l from-transparent to-background/5 pointer-events-none" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};